// extracted by mini-css-extract-plugin
export default {"bannerImage":"GiftSubscriptionLandingPointer_bannerImage__ccloD","title":"GiftSubscriptionLandingPointer_title__aDyeQ","subtitle":"GiftSubscriptionLandingPointer_subtitle__MNdZD"};